/**
 * /jobs/:id — which job page this person sees (threads/job-page-fresh, 10/28).
 *
 * The per-person switch (`job-page.finish-line`, lib/finish-line.ts) used to
 * open the "new" page inside detail.tsx. It now opens the page rebuilt from a
 * clean sheet (fresh/fresh-job-page.tsx). The classic page is unchanged and
 * stays the default. `?page=classic` shows the classic page once without
 * touching the switch (the new page's links to tools it doesn't have yet).
 *
 * 11/4: nobody is forced over. The classic page carries a dated "try it"
 * headline with a "What's missing?" box (fresh/try-new-page.tsx); someone who
 * opened the classic page from the new one is asked what they came for.
 */
import { useParams, useSearchParams } from "react-router-dom";
import { useFinishLineSwitch } from "@/lib/finish-line";
import JobDetailPage from "./detail";
import FreshJobPage from "./fresh/fresh-job-page";
import { TryNewPageBanner } from "./fresh/try-new-page";

export default function JobPageRouter() {
    const { id } = useParams<{ id: string }>();
    const [params] = useSearchParams();
    const sw = useFinishLineSwitch();
    if (sw.on && params.get("page") !== "classic") return <FreshJobPage key={id} />;
    return (
        <>
            <div className="mb-3 empty:hidden">
                <TryNewPageBanner jobId={id} />
            </div>
            <JobDetailPage key={id} />
        </>
    );
}
